import { Component, input, output } from '@angular/core';
import { Notification } from '@umss/shared/data-access';
import { UmssRelativeTimePipe } from '@umss/shared/utils';
import { UmssIconButtonComponent } from '../icon-button/icon-button.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

@Component({
  selector: 'umss-notification-card',
  imports: [
    UmssRelativeTimePipe,
    UmssIconButtonComponent,
    UmssTooltipDirective
  ],
  templateUrl: './notification-card.component.html',
  styleUrl: './notification-card.component.scss'
})
export class NotificationCardComponent {
  notification = input.required<Notification>();
  selected = input(false);

  selectNotification = output<Notification>();
  markAsRead = output<Notification>();

  onSelectNotification(): void {
    this.selectNotification.emit(this.notification());
  }

  onCardKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onSelectNotification();
    }
  }

  onMarkAsRead(event: Event): void {
    event.stopPropagation();
    this.markAsRead.emit(this.notification());
  }
}
